import React, { useState, useEffect } from "react";
import { Row, Col, Modal } from "antd";
import { MailOutlined, NotificationOutlined } from "@ant-design/icons";
import "./Verification.scss";
import Login from "../Login/Login";

import { getParamCaptcha } from "../../../api/others";

const Verification = ({ type, message }) => {

  const [visibleSession, setVisibleSession] = useState(false);

  const [paramCaptcha, setParamCaptcha] = useState(0); //Para ver que captcha mostrar

  useEffect(() => {

    if ( paramCaptcha === undefined ) {
      obtenerParamCaptcha();
      console.log('paramCaptcha en Verificacion',paramCaptcha);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * PEL2025
   * Obtiene el valor del parametro del recaptcha
   * Este valor esta confiurado en un archivo json
   * GlusterFS\observadores\paramCaptcha\paramCaptcha.json
   */
  const obtenerParamCaptcha = () => {
    getParamCaptcha().then((resC) => {

      console.log("Entro en obtenerParamCaptcha()");

      setParamCaptcha(resC.data.paramCaptcha); //0 = captcha google, 1 = captcha react

    }).catch((error) => {
      console.log("Error en servicio web ", error);
      setParamCaptcha(0);
    });
  };

  const success = (
    <div>      
      <Row>
        <Col span={24}>
          <p>
            Ahora puedes
            <button className="btnExample"
                    onClick={(e) => {
                      setVisibleSession(true);
                    }} >

              iniciar sesión
            </button>
            y elaborar tu solicitud 
          </p>
        </Col>
      </Row>

      <Modal title="Iniciar Sesión"
             footer={null}
             open={visibleSession}
             onOk={(e) => {
               setVisibleSession(false);
             }}
             onCancel={(e) => {
               setVisibleSession(false);
             }} >

          <Login visibleSession={visibleSession} paramCaptcha={paramCaptcha}/>

          <div>&nbsp;</div>
      </Modal>
      <MailOutlined style={{ fontSize: "80px", color: "#e149a4" }}/>
    </div>
  );

  const fail = (
    <div>
      <NotificationOutlined style={{ fontSize: "80px", color: "#e149a4" }}/>
    </div>
  );

  return (
    <div className="verification">
      <Row>
        <Col span={24}>
          <h1>{message}</h1>
          <div>{type === 1 ? success : fail}</div><br />
        </Col>        
      </Row>
    </div>
  );
};

export default Verification;
